/**
 * QuoteTotalsBox.jsx — les cinq totaux de la saisie.
 *
 * En lecture seule : sous-total, remise, HT, TVA, TTC.
 *
 * **L'intitule de la taxe ne porte un taux que lorsqu'il y en a un seul.**
 * Des qu'une ligne est exoneree a cote d'une ligne taxable, « TVA (20 %) »
 * surmonte un montant qui n'est pas 20 % du HT affiche juste a cote — la
 * moitie du document seulement est taxee —, et c'est un chiffre qu'on relit
 * trois fois en se demandant lequel est faux. Il dit alors « TVA » tout court,
 * comme le pied du document imprime « Total TVA » suivi de sa ventilation.
 */
import React from 'react';

function TotalItem({ label, value, big, warn, dataTest }) {
  return (
    <div data-testid={dataTest}>
      <div className="text-[10.5px] text-[#8E8FA5] font-semibold uppercase tracking-wide">{label}</div>
      <div
        className={`mt-0.5 font-bold ${big ? 'text-[17px] text-[#4F46E5]' : warn ? 'text-[#D97706]' : 'text-[#1A1B2E]'}`}
        style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
      >
        {value}
      </div>
    </div>
  );
}

export default function QuoteTotalsBox({ totals, tvaRate, fmtEur, plusieursTaux = false }) {
  return (
    <section className="p-4 rounded-xl bg-[#FAFAFE] border border-[#EFF0F6]" data-testid="quote-totals-box">
      <div className="grid grid-cols-5 gap-3 text-[12.5px]">
        <TotalItem label="Sous-total" value={fmtEur(totals.subtotal)} />
        <TotalItem label="Remise" value={totals.discount > 0 ? `-${fmtEur(totals.discount)}` : '—'} warn={totals.discount > 0} />
        <TotalItem label="Total HT" value={fmtEur(totals.ht)} />
        <TotalItem label={plusieursTaux ? 'TVA' : `TVA (${tvaRate}%)`} value={fmtEur(totals.tva)} />
        <TotalItem label="Total TTC" value={fmtEur(totals.ttc)} big dataTest="quote-total-ttc" />
      </div>
    </section>
  );
}
